'use client'

import { Builder } from '@builder.io/react'

import { textStyleMap } from '../Builder/Text/Text'
import { Checklist } from './Checklist'

Builder.registerComponent(Checklist, {
  name: 'Checklist',
  noWrap: true,
  inputs: [
    {
      name: 'textStyle',
      type: 'string',
      defaultValue: 'Body MD',
      enum: Array.from(Object.keys(textStyleMap)),
    },
    {
      name: 'items',
      type: 'list',
      defaultValue: [
        {
          value: '30-day money-back guarantee',
        },
      ],
      subFields: [{ name: 'value', type: 'html' }],
    },
    {
      name: 'checkColor',
      type: 'color',
      defaultValue: '#825BB5',
    },
    {
      name: 'checkIcon',
      type: 'string',
      enum: ['CheckIcon', 'CheckCircleIcon'],
      defaultValue: 'CheckIcon',
    },
    {
      name: 'iconType',
      type: 'string',
      enum: ['outline', 'solid'],
      defaultValue: 'solid',
    },
    {
      name: 'iconSize',
      type: 'number',
      defaultValue: 16,
    },
    {
      name: 'separation',
      type: 'number',
      defaultValue: 8,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/list-check.svg',
})
